import React, { useContext } from "react";
import Headlins from "./Headlins";
import Cart from "./Cart";
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import { Navigation, Scrollbar } from "swiper/modules";
import { MObilehandelrContext } from "./Mobilehandelr";

function Mostsiling() {
  let { isMobile } = useContext(MObilehandelrContext);
  return (
    <section>
      <Headlins suptitle={"Most Selling"} title={"Most Selling"} />
      <Swiper
        slidesPerView={1.3}
        spaceBetween={30}
        loop={true}
        modules={[Navigation, Scrollbar]}
        navigation={{ nextEl: ".rihgt-arrow", prevEl: ".left-arrow" }}
        scrollbar={{
          el: ".swiper-progres",
        }}
        breakpoints={{
          600: {
            slidesPerView: 2.3,
          },
          800: {
            slidesPerView: 3.3,
          },
          1440: {
            slidesPerView: 5.3,
          },
        }}
      >
        <div className="MostAdd">
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
          <SwiperSlide>
            <Cart />
          </SwiperSlide>
        </div>
      </Swiper>
      <div className="swiper-opione">
        <div className="swiper-progres"></div>
        {!isMobile && (
          <div className="swiper-arrows">
            <div className="left-arrow arrow">
              <FaArrowCircleLeft />
            </div>
            <div className="rihgt-arrow arrow">
              <FaArrowCircleRight />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Mostsiling;
